import { IsFavorite } from '@/api/souhuo.js'
import { PLATFORM_SHOP_TYPE, PLATFORM_TYPE, SHOP_TYPE_2 } from '@/constants/index'
export default {
  IsFavorite(params) {
    return new Promise((resolve, reject) => {
      IsFavorite(params).then((res) => {
        resolve(res.Data)
      })
    })
  },
  stringModify(tempStr = '', num = 4) {
    if (!tempStr) {
      return ''
    }
    if (tempStr.length > num) {
      tempStr = tempStr.substring(0, num) + '...'
    }
    return tempStr
  },
  // 格式化价格，整数和小数分开
  SplitPrice(price = '') {
    price = Number(price).toFixed(2)
    return price.toString().split('.')
  },
  // 【PLATFORM_SHOP_TYPE】转【PLATFORM_TYPE】
  shopTypeNumChangeToPlatformType(shopType = 0) {
    const key = Object.keys(PLATFORM_SHOP_TYPE).find((key) => PLATFORM_SHOP_TYPE[key].includes(shopType))
    return PLATFORM_TYPE[key]
  },
  // 【SHOP_TYPE_2】转【PLATFORM_TYPE】
  shopTypeTextChangeToPlatformType(shopTypeText = 'B') {
    const key = Object.keys(SHOP_TYPE_2).find((key) => SHOP_TYPE_2[key] === String(shopTypeText).toLowerCase())
    return PLATFORM_TYPE[key]
  },
  // 【PLATFORM_SHOP_TYPE】转【SHOP_TYPE_2】
  shopTypeNumChangeToText(shopType = 0) {
    const key = Object.keys(PLATFORM_SHOP_TYPE).find((key) => PLATFORM_SHOP_TYPE[key].includes(shopType))
    // 淘宝不展示
    if (key === '淘宝') {
      return ''
    }
    return String(SHOP_TYPE_2[key]).toUpperCase()
  },
  convertImageToBase64(url) {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest()
      xhr.onload = function() {
        const reader = new FileReader()
        reader.onloadend = function() {
          resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsDataURL(xhr.response)
      }
      xhr.onerror = reject
      url = url.replace(/http:/g, 'https:')
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    })
  }
}
